

















































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import { Route } from "vue-router";
import UserService from "@/services/user.service";
import User from "../../models/security/user.model";
import { IdentificationType } from "@/enums/IdentificationType";
import { Quill } from "vue-quill-editor";
import { ImageDrop } from "quill-image-drop-module";
import AvatarCropper from "vue-avatar-cropper";
import { AuthResponse } from "msal";
import myMSALObj from "@/config/azure-b2c/settings";
import GenericAdd from "@/core/Generics/GenericAdd";
import MasterEducation from "@/models/curriculum/masterEducation.Model";
import UserLanguage from "@/models/curriculum/userLanguage.Model";
import CertificationUser from "@/models/curriculum/certificationUser.Model";
import PublicactionUser from "@/models/curriculum/publicactionUser.Model";
import ExperienceUser from "@/models/curriculum/experienceUser.Model";
import ContactUser from "@/models/curriculum/contactUser.Model";
import DocumentComponent from "@/components/PublishAnnoucement/document.vue";
import { CurriculumLevel } from "@/enums/curriculumLevel";
import { CurriculumSource } from "@/enums/curriculumSource";
import GenericEdit from "../../core/Generics/GenericEdit";
import Association from "@/models/curriculum/association.Model";
import ReferenceUser from "../../models/curriculum/referenceUser.Model";
import MaskedInput from "vue-masked-input";
import DatePickerComponent from "@/components/base-datePicker/base-date-picker.vue";
import CertificactionDocument from "@/models/curriculum/certificactionDocument.Model";
import PublicationDocument from "@/models/curriculum/publicationDocument.Model";
import Porposal from "../../models/porposal/porposal.model";
import AcademicTitleService from "../../services/AcademicTitle.service";
import AcademicTitle from "@/models/academic/academicTitle.model";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel";
import carousel from "vue-owl-carousel";
import ResearchCenterBasicInformationComponent from "@/components/research-center-basic-information/researchCenterBasicInformation.vue";
import UserResearchCenter from "../../models/security/userResearchCenter.Model";
@Component({
  components: {
    AvatarCropper,
    MaskedInput,
    documentcomponent: DocumentComponent,
    DatePickerComponent,
    carousel,
    ResearchCenterBasicInformationComponent,
  },
})
export default class Profile extends BaseVue {
  userRequested: User | null = null;
  model: any;
  isCardModalActive = false;
  showWeekNumber = false;
  IdentificationType = IdentificationType;
  userService: UserService = new UserService();
  masterEducations = new MasterEducation();
  userLanguages = new UserLanguage();
  certificationUsers = new CertificationUser();
  publicactionUser = new PublicactionUser();
  experienceUsers = new ExperienceUser();
  curriculumLevel = CurriculumLevel;
  curriculumSource = CurriculumSource;
  loading = false;
  allRoles = [];
  loadingSaving = false;
  show = false;
  token = "";
  userResearchCenters = [];
  message = false;
  private academicTitleService: AcademicTitleService = new AcademicTitleService();
  academicTitles: Array<AcademicTitle> = [];

  constructor() {
    super();
    this.model = new User();
    Quill.register("modules/imageDrop", ImageDrop);
  }
  requestObj = {
    scopes: ["https://mescytportal.onmicrosoft.com/fondocyt-portal/user_impersonation"]
    //copes: ["https://whitecape.onmicrosoft.com/whitecape/user_impersonation"],
  };

  mounted() {
    this.getUser();
    this.getToken();
    this.getAcademicTitles();

    Vue.nextTick(
      function () {
        console.log($("#customers-testimonials"));
        ($("#customers-testimonials") as any).owlCarousel({
          loop: true,
          center: true,
          autoplay: true,
          autoplayTimeout: 5000,
          responsive: {
            0: { items: 1 },
            768: { items: 2 },
            1170: { items: 3 },
          },
        });
      }.bind(this)
    );
  }
  public viewAllRole() {
    this.isCardModalActive = true;
  }

  public getAcademicTitles() {
    this.academicTitleService.getAcademicTitle().then((response) => {
      this.academicTitles = response;
    });
  }

  get user() {
    return this.$store.state.user;
  }
  get urlUpload() {
    if (this.user)
      return `${process.env.VUE_APP_API_URL}User/${this.user.id}/profileImage`;
  }
  editProfile() {
    this.$router.push(`${this.$router.currentRoute.path}/edit/`);
  }
  curriculumUser() {
    this.$router.push(`${this.$router.currentRoute.path}/addCurriculum/`);
  }
  get publiEmpty() {
    return this.model.publicactionUsers;
  }
  onChangeDocs(docs: any[]) {
    this.model.certificationUsers.forEach((element: CertificationUser) => {
      element.certificactionDocuments = docs.map((x) => {
        let doc = new CertificactionDocument();
        doc.documentId = x.documentId;
        doc.document = x.document;
        return doc;
      });
    });
  }
  onChangePublication(docs: any[]) {
    this.model.publicactionUsers.forEach((element: PublicactionUser) => {
      element.publicationDocuments = docs.map((x) => {
        let doc = new PublicationDocument();
        doc.documentId = x.documentId;
        doc.document = x.document;
        return doc;
      });
    });
  }

  public monthNames = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ];

  saveCurriculunm() {
    this.userService.saveCurriculum(this.model).then(() => {
      this.$buefy.toast.open({
        message: "Curriculum guardado con éxito!!!!",
        type: "is-success",
      });
      this.show = false;
    });
  }

  goToProposal(porposal: Porposal) {
    if (porposal.enviada) {
      this.$router.push(`/convocatoria/propuesta/` + porposal.id + `/detail`);
    } else {
      this.$router.push(`/convocatoria/propuesta/` + porposal.id);
    }
  }
  handleUploaded(resp: any) {
    if (this.userRequested) {
      this.userRequested.profileImage = resp;
    }
    this.loadingSaving = false;

    this.$store.commit("setUserImage", resp);
    this.$buefy.toast.open({
      message: "Los cambios se han aplicado correctamente!",
      type: "is-success",
    });
  }
  redirectToRegister() {
    window.open("https://www.google.es/", "_blank");
  }

  showCurriculum() {
    this.$router.push(`/profile/addCurriculum`);
  }

  handleUploading() {
    this.loadingSaving = true;
  }
  changeProfileImage(file: File) {
    if (file.size > 2000000) {
      this.operationFailed(
        "Lo sentimos el tamaño de su imagen debe ser menor a 2MB"
      );
      setTimeout(() => {
        (this.$refs.cropper as any).destroy();
      }, 30);
    }
  }
  get getProfileImage() {
    if (this.userRequested && this.userRequested.profileImage)
      return `data:image/jpg;base64, ${this.userRequested.profileImage}`;

    return false;
  }

  get headers() {
    return {
      Authorization: `Bearer ${this.token}`,
    };
  }

  getImage(image: any) {
    if (image) return `data:image/jpg;base64, ${image}`;
  }

  async getToken() {
    this.token = localStorage.getItem("token");
  }

  getUser() {
    this.loading = true;
    this.userService
      .getUserById(this.user.id)
      .then((user) => {
        this.userRequested = user;
        let promise = user;

        promise.userResearchCenters.forEach(
          (researcenter: UserResearchCenter) => {
            if (
              this.userResearchCenters.some(
                (x: UserResearchCenter) => x.researchCenterId != null
              )
            ) {
              return;
            } else {
              this.userResearchCenters.push(researcenter);
            }
          }
        );

        this.allRoles = promise.allRoles.split(",");
        this.model = promise;
        console.log(promise);
      })
      .finally(() => {
        this.loading = false;
      });
  }
  editorOption = {
    modules: {
      toolbar: [
        ["bold", "italic", "underline"],
        ["blockquote"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ size: ["small", false, "large", "huge"] }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ font: [] }],
        [{ color: [] }, { background: [] }],
        [{ align: [] }],
        ["clean"],
        ["link", "image", "video"],
      ],
      imageDrop: true,
    },
    placeholder: "Escriba el contenido aqui...",
  };
}
